"use clent";

import React from "react";
import "./styles.css";
import "../common.css";
import { InfoUnit } from "../info-unit/info-unit";

export const AboutBlockV2 = ({
	backgroundColor = "#fff",
	borderRadius = 0,
	textColor = "#242323",
}) => {
	return (
		<div
			className="feature__wrapper aboutv2"
			style={{
				background: backgroundColor,
				borderRadius: borderRadius,
				marginTop: borderRadius ? borderRadius * -1 : 0,
				marginBottom: borderRadius ? borderRadius * -1 : 0,
				position: borderRadius ? "relative" : "static",
				color: textColor,
			}}
		>
			<div className="container">
				<div className="about__title">
					<div className="about__hat">
						<div className="about__titlerow">
							<img src="/img/boostpad.png" alt="" className="hiddenlogo" />
							BoostPad
						</div>
						<div className="about__hatinfo">
							Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta
							consequatur et ipsam assumenda et nobis nostrum ex voluptates
							voluptatem ut dolorum asperiores. Non praesentium nulla rem autem
							placeat et consequuntur molestias in natus unde ut facilis
							voluptates
						</div>
					</div>
					<img src="/img/boostpad.png" alt="" />
				</div>

				<div className="about__sideinfo">
					<div className="about__sideunit">
						<div className="about__subtitle">Бренд</div>
						<div>Какой-то бренд</div>
					</div>

					<div className="about__sideunit">
						<div className="about__subtitle">Индустрия</div>
						<div>н-р, e-commerce</div>
					</div>

					<div className="about__sideunit about__sideunit--release">
						<div className="about__subtitle">Релиз</div>
						<div>2023</div>
					</div>

					<div className="about__sideunit">
						<div className="about__subtitle">Бюджет</div>
						<div>$$$$$</div>
					</div>

					<div className="about__sideunit">
						<div className="about__subtitle">Cсылка</div>
						<div>
							<a
								href="http://contactlinklinklink@link.com"
								target="_blank"
								rel="noreferrer"
							>
								contactlinklinklink@link.com
							</a>
						</div>
					</div>
				</div>

				<img src="/img/odin.png" alt="" className="about__widepic" />

				<InfoUnit
					title="Задача"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
				/>

				<InfoUnit
					title="Решение"
					text={[
						"Тут сразу точка А и точка Б с результатом, а уже потом детали и особенности. Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
				/>
			</div>
		</div>
	);
};
